<template>
  <div id="app">
    <!-- <router-view v-title="title" ></router-view> -->
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <!-- <PWAPrompt/> -->
    <MainPage/>
  </div>
</template>

<script>
import MainPage from './components/MainPage.vue'
// import PWAPrompt from './components/PWAPrompt.vue';

export default {
  name: 'App',
  components: {
    // PWAPrompt,
    MainPage
  },
  data(){
    return {
      title: 'Smart Tile Access Pod'
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.stblue-background {
  background-color: #080035;
}
</style>
